module.exports = __webpack_public_path__ + "static/media/5.89de978c.svg";